<template>
  <generic-modal
    size="large"
    :title="$t('inventory output configuration')"
    icon="warehouse"
    image="/images/icons/settings-1.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div class="ui blue form segment">
        <div class="fields">
          <div class="eight wide field">
            <label for>{{ $t("output from inventory rule") }}</label>
            <div class="ui selection dropdown" ref="rule_dropdown">
              <input type="hidden" name="output_rule" />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("select rule") }}</div>
              <div class="menu">
                <div
                  class="item"
                  :data-value="r.value"
                  v-for="(r, idx) in rules"
                  :key="idx"
                >
                  {{ r.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="eight wide field">
            <label for="">{{
              $t("maximum products shown with inventory output")
            }}</label>
            <input
              type="text"
              v-model="max_products_shown_with_inventory_output"
            />
          </div>
        </div>
      </div>
      <generic-container
        v-for="(output, index) in outputs"
        v-bind:key="index"
        icon="layer group"
        :title="output.name"
        v-on:title_click="change_output_name(output)"
        v-bind:header_buttons="header_buttons"
        v-bind:object="output"
      >
        <!-- <div class="ui toggle checkbox" style="margin-bottom:15px">
          <input type="checkbox" name="link_to_pos" v-model="output.link_to_pos" />
          <label>{{ $t("link to point of sale")}}</label>
        </div>-->
        <div class="ui two column grid">
          <div class="column">
            <generic-catalog
              icon="sign out alternate"
              :title="$t('out from inventory attributes')"
              :attributes="output.reason_attributes"
            />
          </div>
          <div class="column">
            <generic-catalog
              icon="sign in alternate"
              :title="$t('out from inventory product attributes')"
              :attributes="output.product_attributes"
            />
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";
import GenericCatalog from "../GenericCatalog";

export default {
  name: "InventoryOutputConfigureModal",
  components: {
    GenericModal,
    GenericContainer,
    GenericCatalog,
  },
  computed: {},
  data() {
    return {
      outputs: [],
      max_products_shown_with_inventory_output: "",
      output_from_inventory_rule: "",
      header_buttons: [
        {
          color: "red",
          icon: "trash",
          click: this.remove_reason,
        },
      ],
      footer_buttons: [
        {
          color: "olive",
          icon: "plus",
          text: this.$i18n.t("add reason"),
          click: this.add_reason,
        },
      ],
      rules: [
        {
          name: this.$t("first in first out"),
          value: "fifo",
        },
        {
          name: this.$t("last in first out"),
          value: "lifo",
        },
        {
          name: this.$t("about to expire first then first in first out"),
          value: "efifo",
        },
        {
          name: this.$t("about to expire first then last in first out"),
          value: "elifo",
        },
      ],
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/inventory/do-save-output-configuration", {
          s: vm.outputs,
          m: vm.max_products_shown_with_inventory_output,
          r: vm.output_from_inventory_rule,
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    add_reason() {
      this.$alertify.promptWithTitle(
        this.$i18n.t("enter name"),
        this.$i18n.t("enter reason name"),
        "",
        (evt, value) => {
          this.outputs.push({
            // link_to_pos: false,
            id: v4(),
            name: value,
            reason_attributes: [],
            product_attributes: [],
          });
        },
        () => {},
      );
    },
    remove_reason(r) {
      let idx = this.outputs.findIndex((n) => n.id == r.id);
      if (idx >= 0) this.outputs.splice(idx, 1);
    },
    change_output_name(output) {
      this.$alertify.promptWithTitle(
        this.$i18n.t("edit name"),
        this.$i18n.t("enter reason name"),
        output.name,
        (evt, value) => {
          output.name = value;
        },
        () => {},
      );
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(this.$refs.rule_dropdown).dropdown({
      onChange(value) {
        vm.output_from_inventory_rule = value;
      },
    });
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/inventory/do-get-output-configuration")
      .then((r) => {
        if (r) {
          vm.outputs = r.outputs;
          vm.max_products_shown_with_inventory_output =
            r.max_products_shown_with_inventory_output;
          if (r.output_from_inventory_rule) {
            vm.output_from_inventory_rule = r.output_from_inventory_rule;
            window
              .jQuery(this.$refs.rule_dropdown)
              .dropdown("set selected", r.output_from_inventory_rule);
          }
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function () {},
};
</script>
